import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

export const getAllCustomers = async (queryParams: { SearchValue: string }) => {
  let data = null;
  if (queryParams) {
    data = await getDataWithDotNet(
      `${ajaxEndpoints.ECOSYSTEMSCUSTOMERS}?${new URLSearchParams(queryParams)}`,
    );
  } else {
    data = await getDataWithDotNet(ajaxEndpoints.ECOSYSTEMS);
  }

  return data.data;
};

export default function useAllCustomers(queryParams: { SearchValue: string }) {
  return useQuery(
    [queryParams, "getAllAggregators"],
    () => getAllCustomers(queryParams),
    {
      refetchOnWindowFocus: false,
    },
  );
}
